import React from 'react'
import { RadioGroup as MuiRadioGroup, FormControlLabel, Radio, InputLabel, Box, FormHelperText } from '@material-ui/core';

interface RadioGroupProps {
    name: string;
    label: string,
    value: any;
    onChange: (e: any) => void;
    items: RadioGroupItemProps[];
    error: any;
}

interface RadioGroupItemProps {
    value: any;
    id: number;
    text: string;
}

export default function RadioGroup(props: RadioGroupProps) {

    const { name, label, value, error, onChange, items } = props;

    return (
        <React.Fragment>
            <Box mt={1}>
                <InputLabel {...(error && { error: true })} style={{"color": (!error ? '#000' : '') }}>{label}</InputLabel>
                <MuiRadioGroup row
                    name={name}
                    value={value}
                    onChange={onChange}>
                    {
                        items.map(
                            item => (
                                <FormControlLabel key={item.value} value={item.value} control={<Radio color="primary" />} label={item.text} />
                            )
                        )
                    }
                </MuiRadioGroup>
                <FormHelperText {...(error && { error: true })}>{error}</FormHelperText>
            </Box>
        </React.Fragment>
    )
}
